export enum Termintyp {
	EINZEL = 0, GRUPPE = 1, TELEFON = 2, ANAMNESE = 3, BEFUND = 4
}
